export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4718.b8b9fefd.jpg";